import router from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import { Color } from "../../../theme/Color";
import Button from "../../Button/Button";
import FeatureRow from "../../FeatureRow";
import FillerImage from "../../Images/FillerImage";
import PageSection, { StyledSectionHeading } from "../../PageSection";
import Spacer from "../../Spacer";

const Features = (props) => {
  return (
    <>
      <PageSection id="features">
        <Spacer top={4} bottom={10}>
          <Row center="xs" middle="xs">
            <StyledSectionHeading>Benefits</StyledSectionHeading>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Direct booking">
                Connect with locals and travellers who can easily find and book
                your services directly.
              </FeatureRow>
              <FeatureRow title="Encourage Repeat Customers">
                Easily communicate and engage with your valued existing
                customers and attract new ones through personal recommendations.
              </FeatureRow>
              <FeatureRow title="Empower Your Customers with Local Knowledge">
                Provide Valmeego Free to your customers and help them discover
                everything in the local area. Enhance your customers experience
                of your locality.
              </FeatureRow>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row center="xs">
                <Spacer top={3} right={1} bottom={3} left={1}>
                  <FillerImage
                    src={props.fillerImageOneURL}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={false} sm={6} md={3}>
              <Row>
                <Spacer top={3} right={1} bottom={1} left={1}>
                  <FillerImage
                    src={props.fillerImageTwoURL}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Boost Your Visibility Locally and Beyond">
                Increase your reach and visibility. Position your business as a
                local favourite and the recommended choice for visitors.
              </FeatureRow>
              <FeatureRow title="Sector Specific Platform">
                Valmeego is tailor-made for the entertainment, hospitality,
                travel and tourism sectors. Businesses and consumers in this
                sector can easily find each other.{" "}
              </FeatureRow>
              <FeatureRow title="Personal Recommendations">
                Harness the power of satisfied customers who can easily
                recommend your business to friends, family, and fellow members
                on Valmeego.
              </FeatureRow>
            </Col>
            <Col xs={8} xsOffset={2} sm={false}>
              <Button
                color="primary"
                label="Sign up"
                size="extra-large"
                onClick={() => {
                  router.push("/personal/register");
                }}
              />
            </Col>
          </Row>
        </Spacer>
      </PageSection>
    </>
  );
};

export default Features;
